export const normalizeHeader = (h) => h.trim().replace(/[^\w\u0590-\u05FF]/g, "").toLowerCase();

export const parseUsersCsvToDict = (csv) => {
  const lines = csv.trim().split("\n").map(line => line.trim()).filter(line => line);
  if (lines.length < 2) throw new Error("CSV must have a header and at least one data row");

  const headers = lines[0].split(",").map(h => normalizeHeader(h));

  const aliases = {
    id: ["תז", "תעודתזהות", "מספרזהות", "id"],
    name: ["שם", "שםמלא", "name", "fullname"],
    expires: ["תאריך", "תאריךתפוגה", "תוקף", "expires", "expirationdate"],
    questionnaire: ["שאלון", "סוג", "סוגשאלון", "questionnaire", "type"],
    gender: ["מגדר", "מין", "gender", "sex"]
  };

  const findColumnIndex = (target) => {
    const targetAliases = aliases[target];
    return headers.findIndex(h => targetAliases.includes(h));
  };

  const idIdx = findColumnIndex("id");
  const nameIdx = findColumnIndex("name");
  const expiresIdx = findColumnIndex("expires");
  const questionnaireIdx = findColumnIndex("questionnaire");
  const genderIdx = findColumnIndex("gender");

  if (idIdx === -1) throw new Error("Missing ID column (ת\"ז / ID)");
  if (nameIdx === -1) throw new Error("Missing Name column (שם / Name)");
  if (expiresIdx === -1) throw new Error("Missing Expires column (תאריך / Expires)");

  const users = lines.slice(1).map((line, i) => {
    const values = line.split(",").map(v => v.trim());

    const name = values[nameIdx];
    const id = values[idIdx];
    const expiresStr = values[expiresIdx].replace(/\r/g, "");
    const expiresDate = new Date(expiresStr);
    const questionnaire = questionnaireIdx !== -1 && values[questionnaireIdx] ? values[questionnaireIdx] : "ahamnon";
    const gender = genderIdx !== -1 && values[genderIdx] ? values[genderIdx] : "-";

    if (!/\p{L}/u.test(name))
      throw new Error(`Invalid name "${name}" at line ${i + 2}`);
    if (!/^\d+$/.test(id))
      throw new Error(`Invalid id "${id}" at line ${i + 2}`);
    if (isNaN(expiresDate.getTime()))
      throw new Error(`Invalid date "${expiresStr}" at line ${i + 2}`);

    return { name, id, username: id, expires: expiresDate.getTime(), originalExpires: expiresStr, questionnaire, gender };
  });
  return { users, isQuestionnaireMissing: questionnaireIdx === -1 };
};
